module.exports = __webpack_public_path__ + "media/promo/panasonic/images/herom-b534ebdc407774a47027ca01b1e59cc3.jpg";